<template>
    <div class="toast-wrap" v-if="showToast">
      <div class="toast">
        <p>{{ toastCon }}</p>
        
      </div>
    </div>
</template>

<script>
export default {
    props:["toastCon","showToast"],
    data(){
        return{

        }
    },
    mounted(){
    },
    methods: {
    }
}
</script>

<style scoped>
.toast-wrap{
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99999999999;
    width: 100%;
    height: 100%;
    background-color: rgba(22, 22, 22, 0.2);
}
.toast{
    display: flex;
    position: absolute;
    padding: 0 30px;
    justify-content: center;
    left: 0;
    top: 40%;
    width: 100vw;
    height: 160px;
    background-color: rgba(22, 22, 22, 0.8);
    font-size: 35px;
    line-height: 50px;
    text-align: center;
    letter-spacing: 3px;
    color: #fff;
}
p{
    align-self: center;
    vertical-align: center;
}
</style>



// WEBPACK FOOTER //
// src/basecomponents/Lesin-toast.vue